const ShoppingCart2Icon = (
  <svg
    className="fill-none"
    width="18"
    height="18"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle
      cx="9"
      cy="20"
      r="1.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <circle
      cx="18"
      cy="20"
      r="1.5"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3 4H5L7.5 15H19L21 7H8"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ShoppingCart2Icon;